if (!window.VPBundle) {
  const blockTypeRegistry = {};
  const coordinators = new Map();

  window.VPBundle = {
    registerBlockType: function (type, handler) {
      if (!type || !handler) return;
      blockTypeRegistry[type] = handler;
    },
    getInstance: function (element) {
      if (element) {
        const builder = element.closest('vp-bundle-builder');
        return builder ? coordinators.get(builder.pdpScope()) || null : null;
      }
      return coordinators.values().next().value || null;
    },
  };

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }

    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    if (!isFinite(cents)) return '';

    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.Shopify && Shopify.money_format) || '';
    const match = formatString.match(placeholder);
    if (!match) return formatString || String(cents);

    function withDelimiters(number, precision, thousands, decimal) {
      if (typeof precision === 'undefined') precision = 2;
      if (typeof thousands === 'undefined') thousands = ',';
      if (typeof decimal === 'undefined') decimal = '.';
      if (isNaN(number) || number == null) return '0';
      const parts = (number / 100.0).toFixed(precision).split('.');
      const major = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const minor = parts[1] ? decimal + parts[1] : '';
      return major + minor;
    }

    let value = '';
    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, '.', '');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholder, value);
  }

  function optionValuesKey(values) {
    return JSON.stringify(values || []);
  }

  function slimSourceProduct(config, handle, productId) {
    const products = (config && config.products) || [];
    for (let index = 0; index < products.length; index++) {
      const product = products[index];
      if (productId != null && product.productId != null && String(product.productId) === String(productId)) {
        return product;
      }
      if (handle && product.handle && String(product.handle) === String(handle)) {
        return product;
      }
    }
    return null;
  }

  function inheritsSize(config, handle, productId) {
    const slim = slimSourceProduct(config, handle, productId);
    if (slim && typeof slim.inheritSize === 'boolean') return slim.inheritSize;
    return !config || config.inheritSize !== false;
  }

  function mapAjaxProduct(raw, sizeOption) {
    const optionList = raw.options || [];
    const variantsRaw = raw.variants || [];
    const sizeName = String(sizeOption || '').toLowerCase();

    const options = optionList.map(function (opt, index) {
      const name = opt && opt.name != null ? String(opt.name) : String(opt);
      const position = opt && opt.position != null ? Number(opt.position) : index + 1;
      const names = (opt && opt.values ? opt.values : []).map(function (value) {
        return typeof value === 'string' ? value : String(value);
      });
      const values = names.map(function (valueName) {
        let swatchImage = '';
        for (let i = 0; i < variantsRaw.length; i++) {
          const variant = variantsRaw[i];
          const optionValues =
            variant.options ||
            [variant.option1, variant.option2, variant.option3].filter(function (part) {
              return part != null && part !== '';
            });
          if (optionValues[index] !== valueName) continue;
          const featured = variant.featured_image;
          swatchImage = (featured && featured.src) || raw.featured_image || '';
          break;
        }
        return {
          name: valueName,
          swatch: swatchImage ? { color: null, image: swatchImage } : null,
        };
      });
      return { name: name, position: position, values: values };
    });

    const variants = variantsRaw.map(function (variant) {
      const optionValues =
        variant.options ||
        [variant.option1, variant.option2, variant.option3].filter(function (part) {
          return part != null && part !== '';
        });
      const featured = variant.featured_image;
      return {
        variantId: variant.id,
        optionValues: optionValues,
        available: !!variant.available,
        price: Number(variant.price),
        compareAtPrice:
          variant.compare_at_price != null && variant.compare_at_price !== ''
            ? Number(variant.compare_at_price)
            : 0,
        image: (featured && featured.src) || raw.featured_image || '',
        mediaId: featured && featured.id ? featured.id : null,
      };
    });

    const variantByOptions = {};
    variants.forEach(function (variant) {
      variantByOptions[optionValuesKey(variant.optionValues)] = variant;
    });

    let sizeIndex = -1;
    options.forEach(function (option, index) {
      if (option.name.toLowerCase() === sizeName) sizeIndex = index;
    });

    const media = (raw.media || [])
      .filter(function (entry) {
        return entry && entry.media_type === 'image';
      })
      .map(function (entry) {
        const preview = entry.preview_image || {};
        return {
          id: entry.id,
          src: entry.src || preview.src || '',
          alt: entry.alt || '',
          width: entry.width || preview.width || 0,
          height: entry.height || preview.height || 0,
        };
      });

    return {
      productId: raw.id,
      title: raw.title,
      handle: raw.handle,
      featuredImage: raw.featured_image || '',
      options: options,
      variants: variants,
      media: media,
      variantByOptions: variantByOptions,
      sizeIndex: sizeIndex,
    };
  }

  const slotGroupHandler = {
    mount: function (el, config, api) {
      this.el = el;
      this.config = config;
      this.api = api;
      this.selections = new Array(Math.max(0, Number(config.slots) || 0)).fill(null);
    },

    warnIfImpossible: function () {
      if (this.config.allowDuplicates) return;
      if (!this.api || typeof this.api.getHydratedProduct !== 'function') return;
      const availableIds = {};
      const products = this.config.products || [];
      let hydratedCount = 0;
      products.forEach(function (product) {
        const hydrated = this.api.getHydratedProduct(product.handle);
        if (!hydrated) return;
        hydratedCount += 1;
        (hydrated.variants || []).forEach(function (variant) {
          if (variant && variant.available && variant.variantId != null) availableIds[variant.variantId] = true;
        });
      }, this);
      if (hydratedCount !== products.length) return;
      const availableCount = Object.keys(availableIds).length;
      const slots = Number(this.config.slots) || 0;
      if (availableCount < slots) {
        console.warn(
          '[vp-bundle-builder] allowDuplicates is false and available variants < slots; pack cannot be completed',
          this.config.id
        );
      }
    },

    findVariantRecord: function (variantId) {
      if (!this.api) return null;
      const id = String(variantId);
      function match(hydrated) {
        if (!hydrated) return null;
        const variant = (hydrated.variants || []).find(function (entry) {
          return String(entry.variantId) === id;
        });
        return variant ? { product: hydrated, variant: variant } : null;
      }
      if (typeof this.api.forEachHydratedProduct === 'function') {
        let found = null;
        this.api.forEachHydratedProduct(function (hydrated) {
          if (found) return;
          found = match(hydrated);
        });
        if (found) return found;
      }
      const products = this.config.products || [];
      for (let index = 0; index < products.length; index++) {
        const found = match(
          typeof this.api.getHydratedProduct === 'function'
            ? this.api.getHydratedProduct(products[index].handle)
            : null
        );
        if (found) return found;
      }
      return null;
    },

    getSelection: function () {
      const list = [];
      const slots = this.selections || [];
      for (let index = 0; index < slots.length; index++) {
        const entry = slots[index];
        if (!entry) continue;
        list.push({
          variantId: entry.variantId,
          productId: entry.productId,
          slotIndex: index,
          quantity: entry.quantity,
          sizeManual: !!entry.sizeManual,
          remapFailed: !!entry.remapFailed,
        });
      }
      return list;
    },

    rejectSlot: function (reason, slotIndex, variantId) {
      this.lastSet = { ok: false, reason: reason, slotIndex: slotIndex, variantId: variantId };
      console.warn('[vp-bundle-builder]', this.config && this.config.id, reason, this.lastSet);
      if (this.el && typeof this.el.dispatchEvent === 'function') {
        this.el.dispatchEvent(
          new CustomEvent('vp:bundle:slot-rejected', {
            bubbles: true,
            detail: Object.assign({ blockId: this.config && this.config.id }, this.lastSet),
          })
        );
      }
      return false;
    },

    setSlot: function (slotIndex, variantId, meta) {
      if (!Array.isArray(this.selections)) {
        this.selections = new Array(Math.max(0, Number(this.config.slots) || 0)).fill(null);
      }

      const index = Number(slotIndex);
      if (!Number.isInteger(index) || index < 0 || index >= this.selections.length) {
        return this.rejectSlot('slotIndex out of range', slotIndex, variantId);
      }

      if (variantId == null || variantId === '') {
        return this.rejectSlot('missing variantId', index, variantId);
      }

      const found = this.findVariantRecord(variantId);
      if (!found) {
        return this.rejectSlot('variantId not in hydrated products', index, variantId);
      }

      this.selections[index] = {
        variantId: found.variant.variantId,
        productId: found.product.productId,
        slotIndex: index,
        quantity: Number(this.config.childQuantity) || 1,
        sizeManual: !!(meta && meta.sizeManual),
        remapFailed: false,
      };
      this.lastSet = { ok: true, reason: null, slotIndex: index, variantId: found.variant.variantId };
      return true;
    },

    clearSlot: function (slotIndex) {
      if (!Array.isArray(this.selections)) return this.rejectSlot('selections missing', slotIndex, null);
      const index = Number(slotIndex);
      if (!Number.isInteger(index) || index < 0 || index >= this.selections.length) {
        return this.rejectSlot('slotIndex out of range', slotIndex, null);
      }
      this.selections[index] = null;
      this.lastSet = { ok: true, reason: null, slotIndex: index, variantId: null };
      return true;
    },

    remapInherited: function () {
      const parent = this.api && typeof this.api.getParent === 'function' ? this.api.getParent() : null;
      const newSize = parent && parent.sizeValue != null ? String(parent.sizeValue) : '';
      if (!newSize) return false;
      let changed = false;

      for (let index = 0; index < this.selections.length; index++) {
        const entry = this.selections[index];
        if (!entry || entry.sizeManual) continue;
        const found = this.findVariantRecord(entry.variantId);
        if (!found) {
          console.warn('[vp-bundle-builder] remap skipped, product not hydrated', entry.productId);
          continue;
        }
        if (!inheritsSize(this.config, found.product.handle, entry.productId)) continue;
        if (found.product.sizeIndex < 0) continue;
        const nextValues = found.variant.optionValues.slice();
        nextValues[found.product.sizeIndex] = newSize;
        const next = found.product.variantByOptions[optionValuesKey(nextValues)];
        if (!next || !next.available) {
          if (next && String(entry.variantId) !== String(next.variantId)) {
            entry.variantId = next.variantId;
            changed = true;
          }
          if (!entry.remapFailed) {
            entry.remapFailed = true;
            changed = true;
          }
          continue;
        }
        if (String(entry.variantId) !== String(next.variantId) || entry.remapFailed) {
          entry.variantId = next.variantId;
          entry.remapFailed = false;
          changed = true;
        }
      }
      return changed;
    },

    validate: function () {
      const slots = this.selections || [];
      let filled = 0;
      const counts = {};
      const invalidSlotIndexes = [];

      for (let index = 0; index < slots.length; index++) {
        const entry = slots[index];
        if (!entry) continue;
        filled += 1;
        const key = String(entry.variantId);
        counts[key] = (counts[key] || 0) + 1;
        const found = this.findVariantRecord(entry.variantId);
        const unavailable = !found || !found.variant.available;
        if (entry.remapFailed || unavailable) invalidSlotIndexes.push(index);
      }

      const duplicateVariantIds = [];
      if (!this.config.allowDuplicates) {
        Object.keys(counts).forEach(function (id) {
          if (counts[id] > 1) duplicateVariantIds.push(id);
        });
      }

      const slotCount = slots.length;
      const minRequired = Number(this.config.minRequired) || 0;
      const requireFull = !!(this.api && this.api.rules && this.api.rules.requireFull);
      const required = requireFull ? slotCount : Math.min(minRequired, slotCount);
      const remaining = Math.max(0, required - filled);

      if (duplicateVariantIds.length) {
        const dup = {};
        duplicateVariantIds.forEach(function (id) {
          dup[String(id)] = true;
        });
        for (let index = 0; index < slots.length; index++) {
          const entry = slots[index];
          if (!entry) continue;
          if (dup[String(entry.variantId)] && invalidSlotIndexes.indexOf(index) === -1) {
            invalidSlotIndexes.push(index);
          }
        }
      }

      return {
        filled: filled,
        required: required,
        remaining: remaining,
        duplicateConflict: duplicateVariantIds.length > 0,
        duplicateVariantIds: duplicateVariantIds,
        invalidSlotIndexes: invalidSlotIndexes,
      };
    },

    reset: function () {
      this.selections = this.selections.map(function () {
        return null;
      });
    },

    resizeSlots: function (nextCount) {
      const n = Math.max(0, Math.floor(Number(nextCount) || 0));
      const current = this.selections || [];
      const next = new Array(n);
      for (let index = 0; index < n; index++) {
        next[index] = index < current.length ? current[index] : null;
      }
      this.selections = next;
      this.config.slots = n;
    },

    countFilledBeyond: function (keepCount) {
      const n = Math.max(0, Math.floor(Number(keepCount) || 0));
      const slots = this.selections || [];
      let count = 0;
      for (let index = n; index < slots.length; index++) {
        if (slots[index]) count += 1;
      }
      return count;
    },
  };

  window.VPBundle.registerBlockType('slot_group', slotGroupHandler);

  class VPBundleBuilder extends HTMLElement {
    connectedCallback() {
      const scope = this.pdpScope();
      const current = coordinators.get(scope);
      if (current && current !== this && current.isConnected) {
        this._satellite = true;
        return;
      }

      coordinators.set(scope, this);
      this._scope = scope;
      this._satellite = false;
      this.instances = new Map();
      this.unsubscribers = [];
      this.parent = {
        productId: 0,
        variantId: 0,
        packSizes: [],
        packSize: 0,
        sizeOption: '',
        sizeValue: '',
        optionNames: [],
      };
      this.rules = { childQuantityMode: 'scaled', requireFull: true };
      this.labels = {};
      this.money = { format: '', formatWithCurrency: '' };
      this.blockConfigs = [];
      this.productCache = new Map();
      this.pickerSizeMemory = new Map();

      this.collectConfig();
      this.mountBlocks();
      this.bindParentVariant();
      this.bindSlotUI();
      this.bindPicker();
      this.bindNativeCartGuard();
      window.vpBundleBuilder = this;
      this.emitChange();
    }

    disconnectedCallback() {
      if (this._satellite) return;

      this.unsubscribers.forEach(function (unsub) {
        if (typeof unsub === 'function') unsub();
      });
      this.unsubscribers = [];
      this.instances.clear();

      if (coordinators.get(this._scope) === this) coordinators.delete(this._scope);
      if (window.vpBundleBuilder === this) window.vpBundleBuilder = null;
    }

    pdpScope() {
      return this.closest('product-info') || this.parentElement || this;
    }

    collectConfig() {
      const scope = this.pdpScope();
      const scripts = scope.querySelectorAll('script[data-vp-bundle-config]');
      const configs = [];

      scripts.forEach(function (script) {
        try {
          const parsed = JSON.parse(script.textContent);
          if (parsed) configs.push(parsed);
        } catch (error) {
          console.warn('[vp-bundle-builder] invalid config JSON', error);
        }
      });

      if (!configs.length) return;

      const first = configs[0];
      this.parent = Object.assign({}, first.parent || this.parent);
      this.parent.packSizes = this.normalizePackSizes(this.parent);
      this.parent.packSize = this.resolvePackSize(this.parent.packSize, this.parent.packSizes);
      this.rules = Object.assign({}, first.rules || this.rules);
      this.labels = Object.assign({}, first.labels || this.labels);
      this.money = Object.assign({}, this.money, first.money || {});
      this.blockConfigs = configs.reduce(function (list, config) {
        return list.concat(config.blocks || []);
      }, []);
    }

    mountBlocks() {
      const scope = this.pdpScope();
      const roots = Array.prototype.slice.call(scope.querySelectorAll('[data-vp-bundle-root]'));
      const api = {
        rules: this.rules,
        getParent: this.getParent.bind(this),
        setPackSize: this.setPackSize.bind(this),
        getHydratedProduct: this.getHydratedProduct.bind(this),
        hydrateProduct: this.hydrateProduct.bind(this),
        forEachHydratedProduct: function (callback) {
          this.productCache.forEach(function (entry) {
            if (entry && entry.payload) callback(entry.payload);
          });
        }.bind(this),
      };

      this.blockConfigs.forEach(function (blockConfig, index) {
        if (!blockConfig || !blockConfig.type) return;
        const proto = blockTypeRegistry[blockConfig.type];
        if (!proto) {
          console.warn('[vp-bundle-builder] no handler registered for block type', blockConfig.type);
          return;
        }

        const instance = Object.create(proto);
        const el = roots[index] || this;
        instance.mount(el, blockConfig, api);
        this.instances.set(String(blockConfig.id), instance);
      }, this);
    }

    bindParentVariant() {
      const scope = this.pdpScope();
      const input = scope.querySelector('input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"], input[name="id"]');
      if (input && input.value) {
        const fromInput = Number(input.value);
        if (fromInput) this.parent.variantId = fromInput;
      }

      this._sectionId = scope.dataset && scope.dataset.section ? scope.dataset.section : null;

      if (typeof subscribe !== 'function') return;

      const eventName =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange
          ? PUB_SUB_EVENTS.variantChange
          : 'variant-change';

      const unsub = subscribe(
        eventName,
        function (event) {
          const data = event && event.data;
          if (!data || !data.variant) return;
          if (this._sectionId && data.sectionId && data.sectionId !== this._sectionId) return;
          if (this._submitting) {
            this._variantChangedDuringSubmit = true;
            return;
          }
          const nextId = Number(data.variant.id);
          if (!nextId || nextId === Number(this.parent.variantId)) return;
          this.parent.variantId = nextId;
          this.parent.sizeValue = this.sizeValueFromVariant(data.variant);
          this.remapInheritedSlots();
          this.emitChange();
        }.bind(this)
      );

      this.unsubscribers.push(unsub);
    }

    bindSlotUI() {
      const onChange = function (event) {
        this.syncSlotUI(event.detail);
        this.syncSubmitUI(event.detail && event.detail.validation);
        this.syncEstimatePrice();
      }.bind(this);
      this.addEventListener('vp:bundle:change', onChange);
      this.unsubscribers.push(
        function () {
          this.removeEventListener('vp:bundle:change', onChange);
        }.bind(this)
      );

      const onClick = function (event) {
        const submit = event.target.closest('[data-vp-bundle-submit]');
        if (submit) {
          event.preventDefault();
          this.addToCart();
          return;
        }

        const remove = event.target.closest('[data-vp-bundle-remove]');
        if (remove) {
          event.preventDefault();
          event.stopPropagation();
          this.clearSlot(remove.getAttribute('data-block-id'), Number(remove.getAttribute('data-slot-index')));
          return;
        }

        const applySize = event.target.closest('[data-vp-pack-size-apply]');
        if (applySize) {
          event.preventDefault();
          const pending = this._packSizePending;
          this.hidePackSizeConfirm();
          if (pending != null) this.setPackSize(pending);
          return;
        }

        const cancelSize = event.target.closest('[data-vp-pack-size-cancel]');
        if (cancelSize) {
          event.preventDefault();
          this.hidePackSizeConfirm();
          this.syncPackSizeRadios();
          return;
        }

        const customize = event.target.closest('[data-vp-bundle-customize]');
        if (customize) {
          event.preventDefault();
          const blockId = customize.getAttribute('data-block-id');
          const index = this.nextEmptySlot(blockId, -1);
          this.openPicker(blockId, index == null ? 0 : index, customize);
          return;
        }

        const slot = event.target.closest('[data-vp-bundle-slot]');
        if (!slot) return;
        event.preventDefault();
        this.openPicker(slot.getAttribute('data-block-id'), Number(slot.getAttribute('data-slot-index')), slot);
      }.bind(this);

      const scope = this.pdpScope();
      scope.addEventListener('click', onClick);
      this.unsubscribers.push(function () {
        scope.removeEventListener('click', onClick);
      });

      const onPackSizeChange = function (event) {
        const input = event.target.closest('[data-vp-pack-size]');
        if (!input || !scope.contains(input)) return;
        if (!this.requestPackSize(Number(input.value))) this.syncPackSizeRadios();
      }.bind(this);
      scope.addEventListener('change', onPackSizeChange);
      this.unsubscribers.push(function () {
        scope.removeEventListener('change', onPackSizeChange);
      });
    }

    bindPicker() {
      const section = this.closest('.shopify-section');
      const sectionKey = section ? section.id.replace('shopify-section-', '') : '';
      // Dawn's modal-dialog moves itself to <body>, so pickers are matched by section, not by DOM ancestry.
      const pickers = Array.prototype.filter.call(
        document.querySelectorAll('modal-dialog[data-vp-bundle-picker]'),
        function (el) {
          return el.getAttribute('data-vp-bundle-picker') === sectionKey;
        }
      );
      if (!pickers.length) return;

      pickers.slice(0, -1).forEach(function (el) {
        el.remove();
      });

      this.picker = pickers[pickers.length - 1];
      if (typeof this.picker.show !== 'function') return;

      const scope = this.pdpScope();
      if (scope && scope.classList) {
        Array.prototype.forEach.call(scope.classList, function (name) {
          if (name.indexOf('color-') === 0 || name === 'gradient') this.picker.classList.add(name);
        }, this);
      }

      this.pickerList = this.picker.querySelector('[data-vp-picker-list]');
      this.pickerPdp = this.picker.querySelector('[data-vp-picker-pdp]');
      this.pickerStatus = this.picker.querySelector('[data-vp-picker-status]');
      this.pickerLabels = {
        title: this.picker.getAttribute('data-vp-picker-title-tpl') || '',
        typeFallback: this.picker.getAttribute('data-vp-picker-type-fallback') || '',
        add: this.picker.getAttribute('data-vp-picker-add-label') || '',
        back: this.picker.getAttribute('data-vp-picker-back-label') || '',
        retry: this.picker.getAttribute('data-vp-picker-retry-label') || '',
        loading: this.picker.getAttribute('data-vp-picker-loading') || '',
        error: this.picker.getAttribute('data-vp-picker-error') || '',
        unavailable: this.picker.getAttribute('data-vp-picker-unavailable') || '',
      };
      this.pickerCardStyle = this.picker.getAttribute('data-vp-card-style') || 'standard';
      this.pickerCardScheme = this.picker.getAttribute('data-vp-card-scheme') || '';

      const back = this.picker.querySelector('[data-vp-picker-back]');
      if (back) back.textContent = this.pickerLabels.back;
      const add = this.picker.querySelector('[data-vp-picker-add]');
      if (add) add.textContent = this.pickerLabels.add;
      const retry = this.picker.querySelector('[data-vp-picker-retry]');
      if (retry) retry.textContent = this.pickerLabels.retry;

      const onClick = function (event) {
        const productBtn = event.target.closest('[data-vp-picker-product]');
        if (productBtn) {
          event.preventDefault();
          this.openPickerProduct(productBtn.getAttribute('data-handle'));
          return;
        }
        const thumb = event.target.closest('[data-vp-picker-thumb]');
        if (thumb) {
          event.preventDefault();
          this.setPickerMedia(thumb.getAttribute('data-media-id'));
          return;
        }
        if (event.target.closest('[data-vp-picker-options]')) return;
        const addBtn = event.target.closest('button[data-vp-picker-add]');
        if (addBtn) {
          event.preventDefault();
          this.addPickerSelection();
          return;
        }
        const backBtn = event.target.closest('button[data-vp-picker-back]');
        if (backBtn) {
          event.preventDefault();
          this.showPickerList();
          return;
        }
        const retryBtn = event.target.closest('button[data-vp-picker-retry]');
        if (retryBtn) {
          event.preventDefault();
          this.openPickerProduct(this.pickerHandle, { variantId: this.pickerRestoreVariantId });
        }
      }.bind(this);

      const onChange = function (event) {
        const input = event.target;
        if (!input || !input.matches('[data-vp-picker-option]')) return;
        this.onPickerOptionChange(input);
      }.bind(this);

      this.picker.addEventListener('click', onClick);
      this.picker.addEventListener('change', onChange);
      this.unsubscribers.push(
        function () {
          if (!this.picker) return;
          this.picker.removeEventListener('click', onClick);
          this.picker.removeEventListener('change', onChange);
        }.bind(this)
      );
    }

    slotButton(blockId, slotIndex) {
      const scope = this.pdpScope();
      const id =
        typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(blockId)) : String(blockId);
      return scope.querySelector(
        '[data-vp-bundle-slot][data-block-id="' + id + '"][data-slot-index="' + slotIndex + '"]'
      );
    }

    filledSlotIndexes(blockId) {
      const filled = {};
      const blocks = this.getState().blocks || {};
      const selections = (blocks[blockId] && blocks[blockId].selections) || [];
      selections.forEach(function (entry) {
        if (!entry || entry.slotIndex == null) return;
        filled[Number(entry.slotIndex)] = entry.variantId;
      });
      return filled;
    }

    nextEmptySlot(blockId, currentIndex) {
      const instance = this.instances.get(String(blockId));
      if (!instance || !instance.config) return null;
      const slots = Number(instance.config.slots) || 0;
      const filled = this.filledSlotIndexes(blockId);
      const start = Number(currentIndex);
      for (let index = start + 1; index < slots; index++) {
        if (filled[index] == null) return index;
      }
      for (let index = 0; index <= start; index++) {
        if (filled[index] == null) return index;
      }
      return null;
    }

    pickerProducts() {
      const instance = this.instances.get(this.pickerBlockId);
      return (instance && instance.config && instance.config.products) || [];
    }

    pickerSizeOptionName() {
      const instance = this.instances.get(this.pickerBlockId);
      const fromBlock = instance && instance.config && instance.config.sizeOption;
      return String(fromBlock || this.parent.sizeOption || '');
    }

    productInheritsSize(handle, productId) {
      const instance = this.instances.get(this.pickerBlockId);
      if (instance && instance.config) {
        return inheritsSize(instance.config, handle, productId);
      }
      let inherit = null;
      this.instances.forEach(function (block) {
        const slim = slimSourceProduct(block.config, handle, productId);
        if (!slim && !(block.config && block.config.products || []).some(function (product) {
          return handle && String(product.handle) === String(handle);
        })) {
          return;
        }
        const next = inheritsSize(block.config, handle, productId);
        if (next) inherit = true;
        else if (inherit == null) inherit = false;
      });
      return inherit !== false;
    }

    firstAvailableSizeValue(product) {
      const sizeIndex = product && product.sizeIndex;
      if (!(sizeIndex >= 0) || !product.options || !product.options[sizeIndex]) return '';
      const names = (product.options[sizeIndex].values || []).map(function (entry) {
        return entry && entry.name != null ? String(entry.name) : '';
      });
      for (let index = 0; index < names.length; index++) {
        const name = names[index];
        if (!name) continue;
        const available = (product.variants || []).some(function (variant) {
          return !!(
            variant &&
            variant.available &&
            String(variant.optionValues && variant.optionValues[sizeIndex]) === name
          );
        });
        if (available) return name;
      }
      return names[0] || '';
    }

    rememberPickerSize(product, sizeValue) {
      if (!product || product.productId == null || sizeValue == null || sizeValue === '') return;
      if (!this.pickerSizeMemory) this.pickerSizeMemory = new Map();
      this.pickerSizeMemory.set(String(product.productId), String(sizeValue));
    }

    slotSelection(blockId, slotIndex) {
      const blocks = this.getState().blocks || {};
      const selections = (blocks[blockId] && blocks[blockId].selections) || [];
      for (let index = 0; index < selections.length; index++) {
        const entry = selections[index];
        if (entry && Number(entry.slotIndex) === Number(slotIndex)) return entry;
      }
      return null;
    }

    updatePickerTitle() {
      const title = this.picker && this.picker.querySelector('[data-vp-bundle-picker-title]');
      if (!title) return;
      const instance = this.instances.get(this.pickerBlockId);
      const tpl =
        (instance && instance.config && instance.config.pickerTitle) ||
        (this.labels && this.labels.pickerTitle) ||
        (this.pickerLabels && this.pickerLabels.title) ||
        '';
      const slots = Number(instance && instance.config && instance.config.slots) || 0;
      const type = this.pickerProductType() || (this.pickerLabels && this.pickerLabels.typeFallback) || '';
      const typeLabel = type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
      title.textContent = String(tpl)
        .replace(/\{type\}/g, typeLabel)
        .replace('{index}', String(this.pickerSlotIndex + 1))
        .replace('{total}', String(slots))
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    pickerProductType() {
      const products = this.pickerProducts();
      const typeOf = function (product) {
        return String((product && product.productType) || '').trim();
      };
      const onPdp = this.picker && this.picker.classList.contains('vp-bundle-picker--pdp');
      if (onPdp && this.pickerProduct) {
        const handle = String(this.pickerProduct.handle || '');
        const current = products.find(function (product) {
          return String(product.handle) === handle;
        });
        if (typeOf(current)) return typeOf(current);
      }
      const types = products.map(typeOf);
      if (!types.length || !types[0]) return '';
      const first = types[0].toLowerCase();
      const shared = types.every(function (value) {
        return value.toLowerCase() === first;
      });
      return shared ? types[0] : '';
    }

    setPickerOpenedBy() {
      const button = this.slotButton(this.pickerBlockId, this.pickerSlotIndex);
      if (button && this.picker) this.picker.openedBy = button;
    }

    setPickerPanel(name) {
      const dialog = this.picker.querySelector('[role="dialog"]');
      if (this.pickerList) this.pickerList.hidden = name !== 'list';
      if (this.pickerPdp) this.pickerPdp.hidden = name !== 'pdp';
      if (this.pickerStatus) this.pickerStatus.hidden = name !== 'status';
      if (this.picker) this.picker.classList.toggle('vp-bundle-picker--pdp', name === 'pdp');
      const back = this.picker.querySelector('[data-vp-picker-back]');
      if (back) back.hidden = name !== 'pdp' || this.pickerProducts().length <= 1;
      if (dialog) dialog.setAttribute('aria-busy', name === 'status' ? 'true' : 'false');
      this.updatePickerTitle();
    }

    showPickerStatus(kind) {
      if (!this.pickerStatus) return;
      this.setPickerPanel('status');
      const message = this.pickerStatus.querySelector('[data-vp-picker-status-message]');
      const spinner = this.pickerStatus.querySelector('.loading__spinner');
      const retry = this.pickerStatus.querySelector('[data-vp-picker-retry]');
      if (message) {
        message.textContent = kind === 'error' ? this.pickerLabels.error : this.pickerLabels.loading;
      }
      if (spinner) spinner.classList.toggle('hidden', kind !== 'loading');
      if (retry) retry.hidden = kind !== 'error';
    }

    openPicker(blockId, slotIndex, opener) {
      this.hidePackSizeConfirm();
      this.syncPackSizeRadios();
      if (!this.picker || !blockId) return;
      const instance = this.instances.get(String(blockId));
      const slotCount = Number(instance && instance.config && instance.config.slots) || 0;
      const nextIndex = Number(slotIndex) || 0;
      if (nextIndex < 0 || nextIndex >= slotCount) return;
      this.pickerBlockId = String(blockId);
      this.pickerSlotIndex = nextIndex;
      this.updatePickerTitle();
      if (opener) this.picker.openedBy = opener;
      else this.setPickerOpenedBy();

      if (!this.picker.hasAttribute('open')) this.picker.show(this.picker.openedBy);

      const products = this.pickerProducts();
      const current = this.slotSelection(this.pickerBlockId, this.pickerSlotIndex);
      if (current && current.productId != null) {
        const match = products.find(function (product) {
          return String(product.productId) === String(current.productId);
        });
        if (match) {
          this.openPickerProduct(match.handle, { variantId: current.variantId });
          return;
        }
      }

      if (products.length <= 1) {
        if (products[0] && products[0].handle) this.openPickerProduct(products[0].handle);
        else this.showPickerStatus('error');
        return;
      }

      this.showPickerList();
    }

    showPickerList() {
      if (!this.pickerList) return;
      const products = this.pickerProducts();
      const list = this.pickerList;
      list.replaceChildren();
      products.forEach(function (product) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vp-bundle-picker__product';
        button.setAttribute('data-vp-picker-product', '');
        button.setAttribute('data-handle', product.handle || '');

        if (product.featuredImage) {
          const media = document.createElement('span');
          media.className = 'vp-bundle-picker__product-media';
          const img = document.createElement('img');
          img.className = 'vp-bundle-picker__product-image';
          img.src = product.featuredImage;
          img.alt = product.title || '';
          img.loading = 'lazy';
          img.width = 400;
          img.height = 400;
          media.appendChild(img);
          button.appendChild(media);
        }

        const name = document.createElement('span');
        name.className = 'vp-bundle-picker__product-name';
        name.textContent = product.title || '';
        button.appendChild(name);
        list.appendChild(button);
      });
      this.setPickerPanel('list');
    }

    openPickerProduct(handle, meta) {
      const key = String(handle || '');
      if (!key) {
        this.showPickerStatus('error');
        return;
      }
      this.pickerHandle = key;
      this.pickerRestoreVariantId = meta && meta.variantId != null ? meta.variantId : null;
      const cached = this.getHydratedProduct(key);
      if (cached) {
        this.renderPickerPdp(cached, this.pickerRestoreVariantId);
        return;
      }
      this.showPickerStatus('loading');
      this.hydrateProduct(key)
        .then(
          function (product) {
            if (this.pickerHandle !== key) return;
            this.renderPickerPdp(product, this.pickerRestoreVariantId);
          }.bind(this)
        )
        .catch(
          function () {
            if (this.pickerHandle !== key) return;
            this.showPickerStatus('error');
          }.bind(this)
        );
    }

    isDefaultOption(option) {
      if (!option) return true;
      const values = option.values || [];
      if (values.length !== 1) return false;
      const name = String(option.name || '').toLowerCase();
      const value = String(values[0].name || '').toLowerCase();
      return name === 'title' && value === 'default title';
    }

    initialPickerValues(product, variantId) {
      const options = product.options || [];
      const values = options.map(function (option) {
        const first = option.values && option.values[0];
        return first ? first.name : '';
      });
      if (variantId != null) {
        const current = (product.variants || []).find(function (variant) {
          return String(variant.variantId) === String(variantId);
        });
        if (current) return current.optionValues.slice();
      }
      const sizeIndex = product.sizeIndex;
      if (!(sizeIndex >= 0)) return values;

      if (!this.productInheritsSize(product.handle, product.productId)) {
        const remembered =
          this.pickerSizeMemory && product.productId != null
            ? this.pickerSizeMemory.get(String(product.productId))
            : '';
        const sizeOption = options[sizeIndex];
        const hasRemembered = !!(
          remembered &&
          (sizeOption.values || []).some(function (entry) {
            return String(entry.name) === String(remembered);
          })
        );
        values[sizeIndex] = hasRemembered ? remembered : this.firstAvailableSizeValue(product);
        return values;
      }

      const parentSize = this.parent && this.parent.sizeValue != null ? String(this.parent.sizeValue) : '';
      if (parentSize) {
        const sizeOption = options[sizeIndex];
        const hasSize = (sizeOption.values || []).some(function (entry) {
          return String(entry.name) === parentSize;
        });
        if (hasSize) values[sizeIndex] = parentSize;
      }
      return values;
    }

    renderPickerPdp(product, variantId) {
      this.pickerProduct = product;
      this.pickerValues = this.initialPickerValues(product, variantId);
      const sizeIndex = product.sizeIndex;
      const parentSize = this.parent && this.parent.sizeValue != null ? String(this.parent.sizeValue) : '';
      const inherits = this.productInheritsSize(product.handle, product.productId);
      this.pickerSizeManual = !inherits || !!(
        variantId != null &&
        sizeIndex >= 0 &&
        this.pickerValues[sizeIndex] &&
        String(this.pickerValues[sizeIndex]) !== parentSize
      );

      const title = this.picker.querySelector('[data-vp-picker-product-title]');
      if (title) title.textContent = product.title || '';

      this.renderPickerGallery(product);
      this.renderPickerOptions(product);
      this.syncPickerVariant();
      this.setPickerPanel('pdp');
    }

    pickerMediaFor(product, mediaId) {
      const media = product.media || [];
      if (mediaId != null && mediaId !== '') {
        for (let index = 0; index < media.length; index++) {
          if (String(media[index].id) === String(mediaId)) return media[index];
        }
      }
      return media[0] || { id: '', src: product.featuredImage || '', alt: product.title || '' };
    }

    renderPickerGallery(product) {
      const root = this.picker.querySelector('[data-vp-picker-gallery]');
      if (!root) return;
      root.replaceChildren();
      const media = product.media && product.media.length ? product.media : [];
      const items = media.length
        ? media
        : product.featuredImage
          ? [{ id: 'featured', src: product.featuredImage, alt: product.title || '' }]
          : [];
      if (!items.length) return;

      const main = document.createElement('img');
      main.className = 'vp-bundle-picker__main-image';
      main.setAttribute('data-vp-picker-main-image', '');
      main.alt = items[0].alt || '';
      main.width = items[0].width || 800;
      main.height = items[0].height || 800;
      root.appendChild(main);

      if (items.length > 1) {
        const thumbs = document.createElement('div');
        thumbs.className = 'vp-bundle-picker__thumbs';
        items.forEach(function (entry) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'vp-bundle-picker__thumb';
          button.setAttribute('data-vp-picker-thumb', '');
          button.setAttribute('data-media-id', String(entry.id));
          const img = document.createElement('img');
          img.src = entry.src;
          img.alt = entry.alt || '';
          img.width = 88;
          img.height = 88;
          img.loading = 'lazy';
          button.appendChild(img);
          thumbs.appendChild(button);
        });
        root.appendChild(thumbs);
      }
    }

    setPickerMedia(mediaId) {
      const product = this.pickerProduct;
      if (!product) return;
      const media = this.pickerMediaFor(product, mediaId);
      const main = this.picker.querySelector('[data-vp-picker-main-image]');
      if (main && media.src) {
        main.src = media.src;
        main.alt = media.alt || '';
        if (media.width) main.width = media.width;
        if (media.height) main.height = media.height;
      }
      this.picker.querySelectorAll('[data-vp-picker-thumb]').forEach(function (thumb) {
        const current = String(thumb.getAttribute('data-media-id')) === String(media.id);
        if (current) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    renderPickerOptions(product) {
      const root = this.picker.querySelector('[data-vp-picker-options]');
      if (!root) return;
      root.replaceChildren();
      const sizeName = this.pickerSizeOptionName().toLowerCase();
      (product.options || []).forEach(
        function (option, optionIndex) {
          if (this.isDefaultOption(option)) return;
          const isSize = String(option.name || '').toLowerCase() === sizeName;
          const fieldset = document.createElement('fieldset');
          fieldset.className =
            'js product-form__input ' + (isSize ? 'product-form__input--pill' : 'product-form__input--swatch');
          const legend = document.createElement('legend');
          legend.className = 'form__label';
          legend.textContent = option.name || '';
          fieldset.appendChild(legend);
          const selected = this.pickerValues[optionIndex];
          (option.values || []).forEach(
            function (entry, valueIndex) {
              const id = 'vp-picker-' + optionIndex + '-' + valueIndex;
              const input = document.createElement('input');
              input.type = 'radio';
              input.id = id;
              input.name = 'vp-picker-option-' + optionIndex;
              input.value = entry.name;
              input.checked = String(entry.name) === String(selected);
              input.setAttribute('data-vp-picker-option', '');
              input.setAttribute('data-option-index', String(optionIndex));
              if (isSize) {
                const label = document.createElement('label');
                label.setAttribute('for', id);
                label.textContent = entry.name;
                const hidden = document.createElement('span');
                hidden.className = 'visually-hidden label-unavailable';
                hidden.textContent = this.pickerLabels.unavailable;
                label.appendChild(hidden);
                fieldset.appendChild(input);
                fieldset.appendChild(label);
              } else {
                input.className = 'swatch-input__input';
                const label = document.createElement('label');
                label.className = 'swatch-input__label';
                label.setAttribute('for', id);
                label.title = entry.name;
                const swatch = document.createElement('span');
                const image = entry.swatch && entry.swatch.image;
                if (image) {
                  swatch.className = 'swatch';
                  swatch.style.setProperty('--swatch--background', 'url("' + image + '")');
                } else {
                  swatch.className = 'swatch swatch--unavailable';
                }
                const sr = document.createElement('span');
                sr.className = 'visually-hidden';
                sr.textContent = entry.name;
                const unavailable = document.createElement('span');
                unavailable.className = 'visually-hidden label-unavailable';
                unavailable.textContent = this.pickerLabels.unavailable;
                label.appendChild(swatch);
                label.appendChild(sr);
                label.appendChild(unavailable);
                fieldset.appendChild(input);
                fieldset.appendChild(label);
              }
            }.bind(this)
          );
          root.appendChild(fieldset);
        }.bind(this)
      );
    }

    currentPickerVariant() {
      const product = this.pickerProduct;
      if (!product) return null;
      return product.variantByOptions[optionValuesKey(this.pickerValues)] || null;
    }

    optionAvailable(optionIndex, valueName) {
      const product = this.pickerProduct;
      if (!product) return false;
      const next = this.pickerValues.slice();
      next[optionIndex] = valueName;
      const variant = product.variantByOptions[optionValuesKey(next)];
      return !!(variant && variant.available);
    }

    syncPickerVariant() {
      const product = this.pickerProduct;
      if (!product) return;
      (product.options || []).forEach(
        function (option, optionIndex) {
          if (this.isDefaultOption(option)) return;
          const isSize = String(option.name || '').toLowerCase() === this.pickerSizeOptionName().toLowerCase();
          this.picker.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(
            function (input) {
              const available = this.optionAvailable(optionIndex, input.value);
              input.checked = String(input.value) === String(this.pickerValues[optionIndex]);
              if (isSize) {
                input.classList.toggle('disabled', !available);
              } else {
                input.classList.toggle('visually-disabled', !available);
              }
            }.bind(this)
          );
        }.bind(this)
      );

      const variant = this.currentPickerVariant();
      const add = this.picker.querySelector('[data-vp-picker-add]');
      if (add) add.disabled = !(variant && variant.available);
      const price = this.picker.querySelector('[data-vp-picker-price]');
      if (price) {
        price.textContent =
          variant && variant.price != null
            ? this.formatMoney(variant.price, this.money.formatWithCurrency || this.money.format)
            : '';
      }
      if (variant) this.setPickerMedia(variant.mediaId);
      else this.setPickerMedia(product.media && product.media[0] && product.media[0].id);
    }

    onPickerOptionChange(input) {
      const optionIndex = Number(input.getAttribute('data-option-index'));
      if (!Number.isInteger(optionIndex) || !this.pickerValues) return;
      this.pickerValues[optionIndex] = input.value;
      if (this.pickerProduct && optionIndex === this.pickerProduct.sizeIndex) {
        this.pickerSizeManual = true;
        this.rememberPickerSize(this.pickerProduct, input.value);
      }
      this.syncPickerVariant();
    }

    addPickerSelection() {
      const variant = this.currentPickerVariant();
      if (!variant || !variant.available) return;
      const inherits = this.productInheritsSize(
        this.pickerProduct && this.pickerProduct.handle,
        this.pickerProduct && this.pickerProduct.productId
      );
      const sizeIndex = this.pickerProduct && this.pickerProduct.sizeIndex;
      if (sizeIndex >= 0 && this.pickerValues) {
        this.rememberPickerSize(this.pickerProduct, this.pickerValues[sizeIndex]);
      }
      const changed = this.setSlot(this.pickerBlockId, this.pickerSlotIndex, variant.variantId, {
        sizeManual: inherits ? !!this.pickerSizeManual : true,
      });
      if (!changed) return;

      const nextIndex = this.nextEmptySlot(this.pickerBlockId, this.pickerSlotIndex);
      if (nextIndex == null) {
        this.picker.hide();
        return;
      }

      this.pickerSlotIndex = nextIndex;
      this.updatePickerTitle();
      this.setPickerOpenedBy();

      const parentSize = this.parent && this.parent.sizeValue != null ? String(this.parent.sizeValue) : '';
      if (inherits && sizeIndex >= 0 && parentSize && this.pickerValues) {
        const sizeOption = this.pickerProduct.options[sizeIndex];
        const hasSize = (sizeOption && sizeOption.values || []).some(function (entry) {
          return String(entry.name) === parentSize;
        });
        if (hasSize) {
          this.pickerValues[sizeIndex] = parentSize;
          this.pickerSizeManual = false;
        }
      }
      this.syncPickerVariant();
    }

    syncSlotUI(detail) {
      if (!detail || !detail.state) return;

      const scope = this.pdpScope();
      const incompleteTemplate = (detail.state.labels && detail.state.labels.incomplete) || '';

      this.instances.forEach(function (instance, blockId) {
        const selector =
          typeof CSS !== 'undefined' && CSS.escape
            ? '[data-vp-bundle-group="' + CSS.escape(blockId) + '"]'
            : '[data-vp-bundle-group="' + blockId + '"]';
        const group = scope.querySelector(selector);
        if (!group) return;
        group.classList.toggle('vp-bundle-slots--highlight-second', this.highlightSecondSlot(instance));

        const slots = Number(instance.config && instance.config.slots) || 0;
        const validation =
          (detail.validation && detail.validation.byBlock && detail.validation.byBlock[blockId]) || {};
        const filled = validation.filled || 0;
        const remaining = validation.remaining || 0;

        const countEl = group.querySelector('[data-vp-bundle-count]');
        if (countEl) countEl.textContent = filled + ' / ' + slots;

        const remainingEl = group.querySelector('[data-vp-bundle-remaining]');
        if (remainingEl) {
          remainingEl.textContent =
            remaining > 0 ? incompleteTemplate.replace('{remaining}', String(remaining)) : '';
        }

        const selections =
          (detail.state.blocks && detail.state.blocks[blockId] && detail.state.blocks[blockId].selections) || [];
        const byIndex = {};
        selections.forEach(function (entry) {
          if (!entry || entry.slotIndex == null) return;
          byIndex[Number(entry.slotIndex)] = entry.variantId;
        });

        const duplicateConflict = !!validation.duplicateConflict;
        const duplicateVariantIds = {};
        (validation.duplicateVariantIds || []).forEach(function (id) {
          duplicateVariantIds[String(id)] = true;
        });

        const emptyTpl = group.getAttribute('data-vp-label-empty') || '';
        const filledTpl = group.getAttribute('data-vp-label-filled') || '';
        const invalidTpl = group.getAttribute('data-vp-label-invalid') || filledTpl;
        const removeTpl = group.getAttribute('data-vp-label-remove') || '';

        for (let index = 0; index < slots; index++) {
          const wrap = group.querySelector('.vp-bundle-slot[data-slot-index="' + index + '"]');
          if (!wrap) continue;

          const variantId = byIndex[index] != null ? byIndex[index] : null;
          const nextId = variantId != null ? String(variantId) : '';
          const prevId = wrap.getAttribute('data-variant-id') || '';
          const isInvalid = Boolean(
            nextId &&
              ((duplicateConflict && duplicateVariantIds[nextId]) ||
                (validation.invalidSlotIndexes || []).indexOf(index) !== -1)
          );
          const nextState = !nextId ? 'empty' : isInvalid ? 'invalid' : 'filled';
          const prevState = wrap.getAttribute('data-state') || 'empty';

          if (prevId === nextId && prevState === nextState) continue;

          wrap.setAttribute('data-state', nextState);
          if (nextId) wrap.setAttribute('data-variant-id', nextId);
          else wrap.removeAttribute('data-variant-id');

          const record =
            nextId && typeof instance.findVariantRecord === 'function' ? instance.findVariantRecord(nextId) : null;
          const optionValue = record ? record.variant.optionValues.join(' / ') : '';
          const slotNumber = String(index + 1);
          const total = String(slots);

          const img = wrap.querySelector('.vp-bundle-slot__image');
          if (img) {
            if (record && record.variant.image) img.src = record.variant.image;
            else img.removeAttribute('src');
          }

          const optionEl = wrap.querySelector('.vp-bundle-slot__option');
          if (optionEl) optionEl.textContent = optionValue;

          const trigger = wrap.querySelector('[data-vp-bundle-slot]');
          if (trigger) {
            const template = !nextId ? emptyTpl : isInvalid ? invalidTpl : filledTpl;
            trigger.setAttribute(
              'aria-label',
              template.replace('{index}', slotNumber).replace('{total}', total).replace('{option}', optionValue)
            );
          }

          const removeBtn = wrap.querySelector('[data-vp-bundle-remove]');
          if (removeBtn) {
            removeBtn.setAttribute('aria-label', removeTpl.replace('{index}', slotNumber));
            if (nextId) removeBtn.removeAttribute('hidden');
            else removeBtn.setAttribute('hidden', '');
          }
        }
      }, this);
    }

    getParent() {
      return {
        productId: this.parent.productId,
        variantId: this.parent.variantId,
        packSizes: (this.parent.packSizes || []).slice(),
        packSize: this.parent.packSize,
        sizeOption: this.parent.sizeOption,
        sizeValue: this.parent.sizeValue,
        optionNames: this.parent.optionNames || [],
      };
    }

    packSizeValues(list) {
      const values = [];
      (Array.isArray(list) ? list : []).forEach(function (entry) {
        const size =
          entry && typeof entry === 'object'
            ? Math.floor(Number(entry.size))
            : Math.floor(Number(entry));
        if (isFinite(size)) values.push(size);
      });
      return values;
    }

    normalizePackSizes(parent) {
      const list = [];
      const seen = {};
      const raw = parent && parent.packSizes;
      (Array.isArray(raw) ? raw : []).forEach(function (entry) {
        const item = entry && typeof entry === 'object' ? entry : { size: entry };
        const size = Math.floor(Number(item.size));
        if (!isFinite(size) || size < 2 || size > 24) {
          console.warn('[vp-bundle-builder] pack size option skipped; size must be 2-24', item);
          return;
        }
        if (seen[size]) return;
        seen[size] = true;
        const next = { size: size };
        if (item.label) next.label = String(item.label);
        if (item.savings) next.savings = String(item.savings);
        if (item.badge) next.badge = String(item.badge);
        if (item.badgeBackground) next.badgeBackground = String(item.badgeBackground);
        if (item.badgeForeground) next.badgeForeground = String(item.badgeForeground);
        if (typeof item.highlightSecondSlot === 'boolean') next.highlightSecondSlot = item.highlightSecondSlot;
        list.push(next);
      });
      if (!list.length) {
        const fallback = Math.floor(Number(parent && parent.packSize) || 0);
        list.push({ size: fallback >= 2 && fallback <= 24 ? fallback : 6 });
      }
      return list;
    }

    resolvePackSize(value, sizes) {
      const values = this.packSizeValues(sizes);
      const next = Math.floor(Number(value) || 0);
      if (values.indexOf(next) !== -1) return next;
      return values[0];
    }

    countPackSizeDiscards(nextSize) {
      let count = 0;
      this.instances.forEach(function (instance) {
        if (!instance || !instance.config || instance.config.slotsFollowPackSize === false) return;
        if (typeof instance.countFilledBeyond === 'function') {
          count += instance.countFilledBeyond(nextSize);
        }
      });
      return count;
    }

    packSizeRoot() {
      return this.pdpScope().querySelector('[data-vp-pack-size-root]');
    }

    hidePackSizeConfirm() {
      this._packSizePending = null;
      this.pdpScope()
        .querySelectorAll('[data-vp-pack-size-confirm]')
        .forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
    }

    showPackSizeConfirm(size, count) {
      this._packSizePending = size;
      const root = this.packSizeRoot();
      const template = root ? root.getAttribute('data-vp-pack-size-discard') || '' : '';
      const message = template.replace('{size}', String(size)).replace('{count}', String(count));
      this.pdpScope()
        .querySelectorAll('[data-vp-pack-size-confirm]')
        .forEach(function (panel) {
          const text = panel.querySelector('[data-vp-pack-size-confirm-text]');
          if (text) text.textContent = message;
          panel.removeAttribute('hidden');
        });
      const apply = this.pdpScope().querySelector('[data-vp-pack-size-apply]');
      if (apply) apply.focus();
    }

    announcePackSize(size) {
      const root = this.packSizeRoot();
      const live = root && root.querySelector('[data-vp-pack-size-live]');
      if (!live) return;
      const template = root.getAttribute('data-vp-pack-size-changed') || '';
      live.textContent = template.replace('{size}', String(size));
    }

    syncPackSizeRadios() {
      const current = Number(this.parent.packSize);
      this.pdpScope()
        .querySelectorAll('[data-vp-pack-size]')
        .forEach(function (input) {
          input.checked = Number(input.value) === current;
        });
    }

    syncPackSizeUI() {
      this.syncPackSizeRadios();
      const scope = this.pdpScope();
      this.instances.forEach(function (instance, blockId) {
        const follow = !instance.config || instance.config.slotsFollowPackSize !== false;
        const visible = follow
          ? Number(this.parent.packSize) || 0
          : Number(instance.config && instance.config.slots) || 0;
        const selector =
          typeof CSS !== 'undefined' && CSS.escape
            ? '[data-vp-bundle-group="' + CSS.escape(blockId) + '"]'
            : '[data-vp-bundle-group="' + blockId + '"]';
        const group = scope.querySelector(selector);
        if (!group) return;
        group.style.setProperty('--vp-bundle-slot-count', String(visible));
        group.querySelectorAll('.vp-bundle-slot').forEach(function (wrap) {
          const index = Number(wrap.getAttribute('data-slot-index'));
          if (index >= visible) wrap.setAttribute('hidden', '');
          else wrap.removeAttribute('hidden');
        });
      }, this);
    }

    requestPackSize(nextSize) {
      const values = this.packSizeValues(this.parent.packSizes);
      const requested = Math.floor(Number(nextSize) || 0);
      if (values.indexOf(requested) === -1) return false;
      const next = this.resolvePackSize(requested, this.parent.packSizes);
      if (next === Number(this.parent.packSize)) {
        this.hidePackSizeConfirm();
        return true;
      }
      const discarded = this.countPackSizeDiscards(next);
      if (discarded > 0) {
        this.showPackSizeConfirm(next, discarded);
        return false;
      }
      return this.setPackSize(next);
    }

    setPackSize(nextSize) {
      const values = this.packSizeValues(this.parent.packSizes);
      const next = this.resolvePackSize(nextSize, this.parent.packSizes);
      if (values.indexOf(next) === -1) return false;
      if (next === Number(this.parent.packSize)) {
        this.hidePackSizeConfirm();
        this.syncPackSizeRadios();
        return false;
      }

      this.parent.packSize = next;
      this.instances.forEach(function (instance) {
        if (!instance || !instance.config || instance.config.slotsFollowPackSize === false) return;
        if (typeof instance.resizeSlots === 'function') instance.resizeSlots(next);
        if (typeof instance.warnIfImpossible === 'function') instance.warnIfImpossible();
      });

      if (
        this.picker &&
        this.picker.hasAttribute('open') &&
        Number(this.pickerSlotIndex) >= next
      ) {
        this.picker.hide();
      }

      this.hidePackSizeConfirm();
      this.syncPackSizeUI();
      this.announcePackSize(next);
      this.emitChange();
      return true;
    }

    highlightSecondSlot(instance) {
      if (!instance || !instance.config || instance.config.type !== 'slot_group') return false;
      const count =
        instance.config.slotsFollowPackSize === false
          ? Number(instance.config.slots) || 0
          : Number(this.parent.packSize) || 0;
      if (count < 2) return false;
      const size = Number(this.parent.packSize);
      const option = (this.parent.packSizes || []).find(function (entry) {
        return Number(entry.size) === size;
      });
      if (option && typeof option.highlightSecondSlot === 'boolean') return option.highlightSecondSlot;
      return !!instance.config.highlightSecondSlot && count === 2;
    }

    sizeValueFromVariant(variant) {
      if (!variant) return this.parent.sizeValue || '';
      const sizeOption = String(this.parent.sizeOption || '').toLowerCase();
      const names = this.parent.optionNames || [];
      let index = -1;
      names.forEach(function (name, optionIndex) {
        if (String(name).toLowerCase() === sizeOption) index = optionIndex;
      });
      if (index < 0) return this.parent.sizeValue || '';
      const options = variant.options || [];
      return options[index] != null ? String(options[index]) : this.parent.sizeValue || '';
    }

    getHydratedProduct(handle) {
      const entry = this.productCache.get(String(handle));
      return entry && entry.payload ? entry.payload : null;
    }

    hydrateProduct(handle) {
      const key = String(handle || '');
      if (!key) return Promise.reject(new Error('missing handle'));
      const existing = this.productCache.get(key);
      if (existing && existing.payload) return Promise.resolve(existing.payload);
      if (existing && existing.promise) return existing.promise;

      const sizeOption = this.parent.sizeOption;
      const promise = fetch('/products/' + encodeURIComponent(key) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('product fetch failed');
          return response.json();
        })
        .then(
          function (raw) {
            const payload = mapAjaxProduct(raw, sizeOption);
            if (payload.sizeIndex < 0 && this.productInheritsSize(key)) {
              console.warn('[vp-bundle-builder] product is missing size option', payload.productId, sizeOption);
            }
            this.productCache.set(key, { payload: payload });
            this.instances.forEach(function (instance) {
              if (typeof instance.warnIfImpossible === 'function') instance.warnIfImpossible();
            });
            return payload;
          }.bind(this)
        )
        .catch(
          function (error) {
            this.productCache.delete(key);
            throw error;
          }.bind(this)
        );

      this.productCache.set(key, { promise: promise });
      return promise;
    }

    remapInheritedSlots() {
      this.instances.forEach(function (instance) {
        if (typeof instance.remapInherited === 'function') instance.remapInherited();
      });
    }

    setParentSize(sizeValue) {
      const next = sizeValue != null ? String(sizeValue) : '';
      if (next === String(this.parent.sizeValue || '')) return false;
      this.parent.sizeValue = next;
      this.remapInheritedSlots();
      this.emitChange();
      return true;
    }

    packDiscountPercent() {
      const size = Number(this.parent && this.parent.packSize);
      const options = (this.parent && this.parent.packSizes) || [];
      let option = null;
      for (let index = 0; index < options.length; index++) {
        if (Number(options[index].size) === size) {
          option = options[index];
          break;
        }
      }
      if (!option) return 0;
      const text = [option.badge, option.savings, option.label].filter(Boolean).join(' ');
      const match = text.match(/(\d+)\s*%/);
      if (!match) return 0;
      const percent = Number(match[1]);
      if (!isFinite(percent) || percent <= 0 || percent >= 100) return 0;
      return percent;
    }

    packPriceTotals() {
      let list = 0;
      let sale = 0;
      this.instances.forEach(function (instance) {
        if (!instance || typeof instance.getSelection !== 'function') return;
        instance.getSelection().forEach(function (entry) {
          if (!entry || entry.variantId == null) return;
          const found =
            typeof instance.findVariantRecord === 'function'
              ? instance.findVariantRecord(entry.variantId)
              : null;
          if (!found || !found.variant) return;
          const qty = Number(entry.quantity) || 1;
          const price = Number(found.variant.price) || 0;
          const compare = Number(found.variant.compareAtPrice) || 0;
          const original = compare > price ? compare : price;
          list += original * qty;
          sale += price * qty;
        });
      });
      const percent = this.packDiscountPercent();
      if (percent > 0 && sale > 0) {
        sale = Math.round((sale * (100 - percent)) / 100);
      }
      return { list: list, sale: sale };
    }

    estimatePriceLabels(source) {
      const regular =
        (source && source.querySelector('.price__regular .visually-hidden')) ||
        (source && source.querySelector('.visually-hidden'));
      const saleNodes = source ? source.querySelectorAll('.price__sale .visually-hidden') : [];
      return {
        regular: regular && regular.textContent ? regular.textContent.trim() : '',
        sale:
          saleNodes.length > 1 && saleNodes[saleNodes.length - 1].textContent
            ? saleNodes[saleNodes.length - 1].textContent.trim()
            : '',
      };
    }

    syncEstimatePrice() {
      const wrap = this.pdpScope().querySelector('[id^="price-"]');
      if (!wrap) return;

      const source = wrap.querySelector('.price:not(.vp-bundle-estimate)');
      let el = wrap.querySelector('[data-vp-bundle-estimate]');
      if (!el) {
        const labels = this.estimatePriceLabels(source);
        el = document.createElement('div');
        el.className = 'price price--large vp-bundle-estimate';
        el.setAttribute('data-vp-bundle-estimate', '');
        el.setAttribute('role', 'status');
        el.innerHTML =
          '<div class="price__container">' +
          '<div class="price__regular">' +
          (labels.regular
            ? '<span class="visually-hidden visually-hidden--inline">' + labels.regular + '</span>'
            : '') +
          '<span class="price-item price-item--regular" data-vp-estimate-regular></span>' +
          '</div>' +
          '<div class="price__sale">' +
          (labels.regular
            ? '<span class="visually-hidden visually-hidden--inline">' + labels.regular + '</span>'
            : '') +
          '<span><s class="price-item price-item--regular" data-vp-estimate-compare></s></span>' +
          (labels.sale
            ? '<span class="visually-hidden visually-hidden--inline">' + labels.sale + '</span>'
            : '') +
          '<span class="price-item price-item--sale price-item--last" data-vp-estimate-sale></span>' +
          '</div>' +
          '</div>';
        wrap.appendChild(el);
      }

      const totals = this.packPriceTotals();
      const format = this.money.formatWithCurrency || this.money.format;
      const saleText = this.formatMoney(totals.sale, format);
      const onSale = totals.list > totals.sale;
      el.classList.toggle('price--on-sale', onSale);

      const regularEl = el.querySelector('[data-vp-estimate-regular]');
      const compareEl = el.querySelector('[data-vp-estimate-compare]');
      const saleEl = el.querySelector('[data-vp-estimate-sale]');
      if (regularEl) regularEl.textContent = saleText;
      if (saleEl) saleEl.textContent = saleText;
      if (compareEl) compareEl.textContent = onSale ? this.formatMoney(totals.list, format) : '';
    }

    formatMoney(cents, format) {
      return formatMoney(cents, format || this.money.format);
    }

    getState() {
      const blocks = {};
      this.instances.forEach(function (instance, blockId) {
        blocks[blockId] = {
          type: instance.config && instance.config.type,
          selections: typeof instance.getSelection === 'function' ? instance.getSelection() : [],
        };
      });

      return {
        parent: this.getParent(),
        rules: Object.assign({}, this.rules),
        labels: Object.assign({}, this.labels),
        blocks: blocks,
      };
    }

    setSlot(blockId, slotIndex, variantId, meta) {
      const instance = this.instances.get(String(blockId));
      if (!instance || typeof instance.setSlot !== 'function') return false;
      const changed = instance.setSlot(slotIndex, variantId, meta);
      if (changed && !this._silentChange) this.emitChange();
      return changed;
    }

    clearSlot(blockId, slotIndex) {
      const instance = this.instances.get(String(blockId));
      if (!instance || typeof instance.clearSlot !== 'function') return false;
      const changed = instance.clearSlot(slotIndex);
      if (changed && !this._silentChange) this.emitChange();
      return changed;
    }

    validate() {
      const byBlock = {};
      let totalRemaining = 0;
      let valid = true;

      this.instances.forEach(function (instance, blockId) {
        const result =
          typeof instance.validate === 'function'
            ? instance.validate()
            : { filled: 0, required: 0, remaining: 0 };
        byBlock[blockId] = {
          filled: result.filled || 0,
          required: result.required || 0,
          remaining: result.remaining || 0,
          duplicateConflict: !!result.duplicateConflict,
          duplicateVariantIds: result.duplicateVariantIds || [],
          invalidSlotIndexes: result.invalidSlotIndexes || [],
        };
        totalRemaining += byBlock[blockId].remaining;
        if (
          byBlock[blockId].remaining > 0 ||
          byBlock[blockId].duplicateConflict ||
          byBlock[blockId].invalidSlotIndexes.length
        ) {
          valid = false;
        }
      });

      return {
        valid: valid,
        byBlock: byBlock,
        totalRemaining: totalRemaining,
      };
    }

    reset() {
      this.instances.forEach(function (instance) {
        if (typeof instance.reset === 'function') instance.reset();
      });
      this.emitChange();
    }

    emitChange() {
      this.dispatchEvent(
        new CustomEvent('vp:bundle:change', {
          bubbles: true,
          detail: {
            state: this.getState(),
            validation: this.validate(),
          },
        })
      );
    }

    getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    cartSectionIds() {
      const cart = this.getCart();
      if (!cart || typeof cart.getSectionsToRender !== 'function') {
        console.warn('[vp-bundle-builder] cart getSectionsToRender is missing; drawer will not refresh');
        return null;
      }
      const ids = cart.getSectionsToRender().map(function (section) {
        return section && section.id;
      }).filter(function (id) {
        return id != null && id !== '';
      });
      if (!ids.length) {
        console.warn('[vp-bundle-builder] cart getSectionsToRender returned no section ids');
        return null;
      }
      return ids;
    }

    readQuantity() {
      const input = this.pdpScope().querySelector('input.quantity__input[name="quantity"], input[name="quantity"]');
      const value = input ? parseInt(input.value, 10) : 1;
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    productForm() {
      return this.pdpScope().querySelector('product-form');
    }

    bindNativeCartGuard() {
      const scope = this.pdpScope();
      if (scope && scope.classList) scope.classList.add('vp-bundle-has-builder');

      const form = scope.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const onSubmit = function (event) {
          event.preventDefault();
          event.stopPropagation();
        };
        form.addEventListener('submit', onSubmit);
        this.unsubscribers.push(function () {
          form.removeEventListener('submit', onSubmit);
        });
      }

      if (document.querySelector('cart-drawer')) {
        this.submitButtons().forEach(function (button) {
          button.setAttribute('aria-haspopup', 'dialog');
        });
      }
    }

    submitButtons() {
      return this.pdpScope().querySelectorAll('[data-vp-bundle-submit]');
    }

    syncSubmitUI(validation) {
      const result = validation || this.validate();
      const remaining = result.totalRemaining || 0;
      const canSubmit = !!result.valid && !this._submitting;
      let label = this.labels.addToCart || '';
      if (!result.valid && remaining > 0) {
        label = (this.labels.incomplete || '').replace('{remaining}', String(remaining));
      }

      this.submitButtons().forEach(function (button) {
        const text = button.querySelector('[data-vp-bundle-submit-label]');
        if (text && !this._submitting) text.textContent = label;
        if (canSubmit) {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('disabled', '');
          button.setAttribute('aria-disabled', 'true');
        }
        if (this._submitting) button.classList.add('loading');
        else button.classList.remove('loading');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !this._submitting);
      }, this);
    }

    setSubmitting(isSubmitting) {
      this._submitting = !!isSubmitting;
      this.syncSubmitUI(this.validate());
    }

    shopifyErrorText(response) {
      if (!response) return '';
      const description = response.description;
      if (typeof description === 'string' && description) return description;
      if (Array.isArray(description)) return description.filter(Boolean).join(' ');
      if (description && typeof description === 'object') {
        return Object.keys(description)
          .map(function (key) {
            return description[key];
          })
          .filter(Boolean)
          .join(' ');
      }
      if (typeof response.message === 'string') return response.message;
      return '';
    }

    showCartError(message, productVariantId, errors) {
      const form = this.productForm();
      if (form && typeof form.handleErrorMessage === 'function') {
        form.handleErrorMessage(message || false);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'vp-bundle-builder',
          productVariantId: productVariantId,
          errors: errors,
          message: message,
        });
      }
    }

    clearCartError() {
      const form = this.productForm();
      if (form && typeof form.handleErrorMessage === 'function') {
        form.handleErrorMessage(false);
      }
    }

    collectChildItems(parentId, childScale) {
      const items = [];
      let nestedSelf = false;
      this.instances.forEach(function (instance) {
        if (!instance || typeof instance.getSelection !== 'function') return;
        instance.getSelection().forEach(function (entry) {
          if (!entry || entry.variantId == null) return;
          if (String(entry.variantId) === String(parentId)) {
            nestedSelf = true;
            return;
          }
          const unit = Number(entry.quantity) || 1;
          items.push({
            id: Number(entry.variantId),
            quantity: unit * childScale,
            parent_id: Number(parentId),
          });
        });
      });
      return { items: items, nestedSelf: nestedSelf };
    }

    previewAddPayload() {
      const parentId = Number(this.parent.variantId);
      const packCount = this.readQuantity();
      const perPack = this.rules.childQuantityMode === 'per_pack';
      const parentQty = perPack ? 1 : packCount;
      const childScale = perPack ? 1 : packCount;
      const children = this.collectChildItems(parentId, childScale);
      const items = [{ id: parentId, quantity: parentQty }].concat(children.items);
      const body = { items: items };
      const sections = this.cartSectionIds();
      if (sections) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      return {
        body: body,
        packCount: packCount,
        perPack: perPack,
        parentId: parentId,
        nestedSelf: children.nestedSelf,
      };
    }

    cartAddConfig(body) {
      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers = Object.assign({}, config.headers);
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);
      return config;
    }

    postCartAdd(body) {
      const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      return fetch(url, this.cartAddConfig(body)).then(function (response) {
        return response.json();
      });
    }

    refreshCart(response) {
      const cart = this.getCart();
      if (!cart) return;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
      if (typeof cart.renderContents === 'function' && response && response.sections) {
        cart.renderContents(response);
      }
      if (cart.classList && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    }

    syncParentAfterSubmit() {
      if (!this._variantChangedDuringSubmit) return;
      this._variantChangedDuringSubmit = false;
      const input = this.pdpScope().querySelector(
        'input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"], input[name="id"]'
      );
      const nextId = input ? Number(input.value) : 0;
      if (!nextId || nextId === Number(this.parent.variantId)) return;
      this.parent.variantId = nextId;
      this.remapInheritedSlots();
      this.emitChange();
    }

    addToCart() {
      if (this._submitPromise) return this._submitPromise;
      this._submitPromise = this.runAddToCart().finally(
        function () {
          this._submitPromise = null;
        }.bind(this)
      );
      return this._submitPromise;
    }

    runAddToCart() {
      const validation = this.validate();
      if (!validation.valid) {
        return Promise.resolve({ ok: false, reason: 'invalid', validation: validation, packsAdded: 0 });
      }

      const snapshot = this.previewAddPayload();
      if (!snapshot.parentId) {
        return Promise.resolve({ ok: false, reason: 'missing parent variant', packsAdded: 0 });
      }
      if (snapshot.nestedSelf) {
        console.warn('[vp-bundle-builder] a child variant cannot nest under itself', snapshot.parentId);
        return Promise.resolve({ ok: false, reason: 'nested self', packsAdded: 0 });
      }
      if (snapshot.body.items.length < 2) {
        return Promise.resolve({ ok: false, reason: 'no children', packsAdded: 0 });
      }

      const body = JSON.parse(JSON.stringify(snapshot.body));
      const parentId = snapshot.parentId;
      const packCount = snapshot.perPack ? snapshot.packCount : 1;

      this.clearCartError();
      this.setSubmitting(true);

      let packsAdded = 0;
      let lastSuccess = null;

      const sendOnce = function () {
        return this.postCartAdd(body);
      }.bind(this);

      const run = function (index) {
        if (index >= packCount) {
          return Promise.resolve({ ok: true, packsAdded: packsAdded, response: lastSuccess });
        }
        return sendOnce()
          .then(
            function (response) {
              if (response && response.status) {
                const message = this.shopifyErrorText(response);
                this.showCartError(message, parentId, response.errors || response.description);
                if (packsAdded > 0) {
                  console.warn('[vp-bundle-builder] packs added before error', packsAdded, packCount);
                  this.refreshCart(lastSuccess);
                }
                return {
                  ok: false,
                  reason: 'cart',
                  packsAdded: packsAdded,
                  packsRequested: packCount,
                  error: message,
                  response: response,
                };
              }
              packsAdded += 1;
              lastSuccess = response;
              return run(index + 1);
            }.bind(this)
          )
          .catch(
            function (error) {
              console.error(error);
              if (packsAdded > 0) {
                console.warn('[vp-bundle-builder] packs added before error', packsAdded, packCount);
                this.refreshCart(lastSuccess);
              }
              return { ok: false, reason: 'network', packsAdded: packsAdded, packsRequested: packCount, error: error };
            }.bind(this)
          );
      }.bind(this);

      return run(0)
        .then(
          function (result) {
            if (result && result.ok && lastSuccess) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'vp-bundle-builder',
                  productVariantId: parentId,
                  cartData: lastSuccess,
                });
              }
              this.refreshCart(lastSuccess);
            }
            return result;
          }.bind(this)
        )
        .finally(
          function () {
            this.setSubmitting(false);
            this.syncParentAfterSubmit();
          }.bind(this)
        );
    }
  }

  if (!customElements.get('vp-bundle-builder')) {
    customElements.define('vp-bundle-builder', VPBundleBuilder);
  }
}
